import * as net from 'util/Net';

export interface AgentFactoryCanvasPreviewResponse {
  signedUrl: string;
  // ISO 8601 timestamp string (`datetime.isoformat()` on the backend).
  expiresAt: string;
}

export function getAgentFactoryCanvasPreviewUrl(
  agentFactoryId: string,
  filePath: string = 'index.html'
): Promise<AgentFactoryCanvasPreviewResponse> {
  return net.postJSONPromise({
    url: `/1/api/llm/agent-factories/${agentFactoryId}:render-overview-canvas`,
    data: {filePath},
  });
}
